import { createContext } from 'react';
const CurrencyInfoContext = createContext({});

export default CurrencyInfoContext;
